import { useSubscribers } from "../../../../store/subscription/useSubscribers";

import { SubscriberController } from "../../../../services/controllers/subscription";

import { Alert } from "../../../../components/ui/Alert";

export function AlertPauseSubscription() {
  const details = useSubscribers(st => st.data.details)
  const processing = useSubscribers(st => st.data.pauseSending)

  const CSubscriber = SubscriberController();

  if (!details) return null

  return (
    <Alert.Root name={CSubscriber.pauseSubscriptionAlertName}>
      <Alert.Content>
        <Alert.Title>Pausar Assinatura</Alert.Title>
        <ul className="space-y-3 mb-10">
          <li>Cliente irá receber por Email um link para <strong className="highlight">PAUSAR A ASSINATURA</strong>;</li>
          <li>Quando entrar nesse link, o cliente deverá confirmar a solicitação de pausa;</li>
          <li>{details.pausePolicy?.rule}</li>
          <li>A assinatura permanecerá <strong className="highlight">PAUSADA</strong> até o fim do período de pausa;</li>
          <li>O link expira em 24 horas.</li>
          {details.pausePolicy?.cutoffDays > 0 && (
            <li>
              <strong className="highlight">A pausa não pode ser confirmada nos {details.pausePolicy.cutoffDays} dias anteriores à próxima cobrança.</strong>
              {details.pausePolicy.cutoffDate && details.pausePolicy.cutoffDate !== '—' && (
                <> Para esta assinatura, o bloqueio começa em <strong className="highlight">{details.pausePolicy.cutoffDate}</strong>.</>
              )}
            </li>
          )}
          <li>A próxima cobrança será adiada pelos dias da pausa. A assinatura precisa estar ativa e sem faturas pendentes.</li>
          {details.pausePolicy?.reason && <li role="status">{details.pausePolicy.reason}</li>}
          <li><strong className="highlight">📱 A pausa também pode ser feita pelo APP.</strong></li>
        </ul>
        <Alert.Actions>
          <Alert.Cancel>Cancelar</Alert.Cancel>
          <Alert.Confirm
            disabled={processing || !details.pausePolicy?.eligible}
            onClick={() => CSubscriber.pauseSubscribers(false, true)}
          >
            {processing ? "Enviando..." : "Enviar"}
          </Alert.Confirm>
        </Alert.Actions>
      </Alert.Content>
    </Alert.Root>
  )
}
